import { useState } from 'react';
import { Form, Container, Toast, ToastContainer } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from './CustomerLoginPageApi';
import Button from '../../components/atoms/button/Button';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSend = async (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setToastMessage('Please enter a valid email address');
      setToastVariant('danger');
      setShowToast(true);
      return;
    }

    setIsLoading(true);

    try {
      const result = await forgotPassword(email);
      if (result && result.success === true && result.data != 'NotFound') {
        setToastMessage('If your email is registered, a reset link has been sent!');
        setToastVariant('success');
        setEmail('');
      } else {
        setToastMessage(result.error || 'Email not found. Please check your email address.');
        setToastVariant('danger');
      }
    } catch (error) {
      setToastMessage('Network error. Please try again.');
      setToastVariant('danger');
    } finally {
      setIsLoading(false);
      setShowToast(true);

      setTimeout(() => {
        navigate('/customer-login');
      }, 6000);
    }
  };

  const handleCancel = () => {
    navigate('/customer-login');
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh', backgroundColor: '#666' }}
    >
      <Container className="p-4 bg-white rounded shadow" style={{ maxWidth: '500px' }}>
        <h4 className="text-center mb-2">Forgot Password</h4>
        <p className="text-center text-muted mb-4">Please enter your registered email address</p>

        <Form onSubmit={handleSend}>
          <Form.Group controlId="formEmail">
            <Form.Control
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <div className="d-flex flex-md-row justify-content-end gap-2 mt-4">
            <Button
              variant="outlined"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="active"
            >
              Send
            </Button>
          </div>
        </Form>
      </Container>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={6000}
          autohide
        >
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default ForgotPassword;
